import { Injectable } from "@angular/core";
import { ServiceOffLine } from "./Service/bd-offline.service";
import { M3Procesos } from "../Registro/m3-procesos";
import { M3RegService } from "../Services/m3-reg-service";
import { PostServiceM3 } from "../../ConexionSQL/posts.service";
import { ServiceM3Maestro } from "../Services/M3Maestro.service";
import { bdOffLineLog } from "./Service/bd-offline-log.service";
import * as moment_ from 'moment';
const moment = moment_;

@Injectable({
    providedIn: 'root'
})
export class M3ProcesosOffline {

    //private sKeyCtivos: string = "CTIVOS";
    constructor(private oServiceOffLine: ServiceOffLine, private oPostServiceM3: PostServiceM3,
        private obdOffLineLog: bdOffLineLog) {

    }

    /**
     * Obtener M3Procesos, segun el ID M3
     * @param id Id del Motor 3
     * @param ResponseOKLoadM3Procesos Respuesta OK de get de M3 procesos
     * @param ResponseErrorLoadM3Procesos Respuesta Error de get de M3 procesos
     */
    public GetProcesoById(id, ResponseOKLoadM3Procesos: Function, ResponseErrorLoadM3Procesos: Function) {
        //JAGM 20191108 cambio de donde traer el proceso lo trae desde offline
        this.oServiceOffLine.get(id).then(proceso => {
            //this.obdOffLineLog.get(id).then(proceso => {
            ResponseOKLoadM3Procesos(proceso);
        }, error => {
            //ResponseErrorLoadM3Procesos(error);
            this.GetProcesoByIdFromLog(id, ResponseOKLoadM3Procesos, ResponseErrorLoadM3Procesos);
        });
    }


    public GetProcesoByIdFromLog(id, ResponseOKLoadM3Procesos: Function, ResponseErrorLoadM3Procesos: Function) {
        //JAGM 20191108 cambio de donde traer el proceso lo trae desde offline
        //this.oServiceOffLine.get(id).then(proceso => {
        this.obdOffLineLog.get(id).then(proceso => {
            ResponseOKLoadM3Procesos(proceso);
        }, error => {
            ResponseErrorLoadM3Procesos(error);
        });
    }

    /**
     * Adicionar M3 Procesos
     * @param id Id del M3 Proceso
     * @param olM3Procesos Objeto M3 Procesos a agregar
     * @param ResponseOKLoadM3Procesos Funcion OK respuesta que atraparÃ¡.
     */
    public AddProceso(idkatios: string, olM3Procesos: M3Procesos, ResponseOKLoadM3Procesos: Function) {

        if (olM3Procesos.IdM3) {
            this.AddToDocOffline(olM3Procesos, ResponseOKLoadM3Procesos);
        } else {
            this.GetIdM3Offline(idkatios, olM3Procesos.TMIdProceso, olM3Procesos.Ubic1.toString(), olM3Procesos.IDHub.toString()).then(id => {
                olM3Procesos.IdM3 = id;
                this.AddToDocOffline(olM3Procesos, ResponseOKLoadM3Procesos);
            });
        }
    }

    public AddToDocOffline(olM3Procesos: M3Procesos, ResponseOKLoadM3Procesos: Function, intento = 0) {
        this.oServiceOffLine.AddDocument(olM3Procesos.IdM3.toString(), olM3Procesos).then(x => {
            this.SaveIdM3(olM3Procesos.IdM3, olM3Procesos.TMIdProceso, olM3Procesos.Ubic1.toString(), olM3Procesos.IDHub.toString());
            // this.AddLogOffline(olM3Procesos).then(x => {
            //     this.SaveIdM3(olM3Procesos.IdM3, olM3Procesos.TMIdProceso, olM3Procesos.Ubic1.toString(), olM3Procesos.IDHub.toString());
            //     ResponseOKLoadM3Procesos(olM3Procesos.IdM3);
            // }, error => {
            //     console.log(error);
            // });
            this.AddLogOffline(olM3Procesos, ResponseOKLoadM3Procesos);

            //ResponseOKLoadM3Procesos(olM3Procesos.IdM3);
        }, error => {
            console.log(error);
            var sFechaNow: string = moment(new Date()).format('YYYYMMDDTHHmmss')
            localStorage.setItem("errorLog" + sFechaNow, JSON.stringify({ "error": error, "olM3Procesos": olM3Procesos, "Intento": intento, "function": "AddToDocOffline" }));
            if (intento == 0) {
                this.obdOffLineLog.InstanceAgain();
                this.AddToDocOffline(olM3Procesos, ResponseOKLoadM3Procesos, 1);
            } else {
                ResponseOKLoadM3Procesos({ "Error": "Error en guardar en base de datos pcpal." })
            }
        });
    }

    /**
     * Adicionar log offline de procesos.
     * @param olM3Procesos 
     */
    public AddLogOffline(olM3Procesos: M3Procesos, ResponseOKLoadM3Procesos: Function, intento: number = 0) {
        //Agregar a Log Socket
        //this.AddLogSocket(olM3Procesos)
        //return this.obdOffLineLog.AddDocument(olM3Procesos.IdM3.toString(), olM3Procesos)
        this.obdOffLineLog.AddDocument(olM3Procesos.IdM3.toString(), olM3Procesos).then(x => {
            console.log(x);
            ResponseOKLoadM3Procesos(olM3Procesos.IdM3);
        }, error => {
            console.log(error);
            var sFechaNow: string = moment(new Date()).format('YYYYMMDDTHHmmss')
            localStorage.setItem("errorLog" + sFechaNow, JSON.stringify({ "error": error, "olM3Procesos": olM3Procesos, "Intento": intento, "function": "AddLogOffline" }));
            if (intento == 0) {
                this.obdOffLineLog.InstanceAgain();
                this.AddLogOffline(olM3Procesos, ResponseOKLoadM3Procesos, 1);
            } else {
                ResponseOKLoadM3Procesos({ "Error": "Error en guardar en base de datos local." })
            }
        });
    }




    public AddLogSocketOK = () => {

    }

    public closeInstanceLogOff() {
        this.obdOffLineLog.closeInstance();
    }


    public GetOffLineLog() {
        return this.obdOffLineLog.GetAllDocs();
    }


    public Get1DocOffLineLog(id) {
        return this.obdOffLineLog.get(id);
    }

    /**
     * Reversar m3 proceso, en el log local.
     */
    public ReversarEnLog(id) {
        this.Get1DocOffLineLog(id).then(oM3P => {
            var oResult: M3Procesos = oM3P;
            for (var i = 0; i < oResult.lM3PEncFP.length; i++) {
                oResult.lM3PEncFP[i].ValCambio = 0;
                oResult.lM3PEncFP[i].Valor = 0;
                oResult.lM3PEncFP[i].ValOtraClasi = 0;
            }
            oResult.IdEstado = "RV";
            this.AddLogOffline(oResult, null);
        });
    }

    public DestruirBDLog(funcionResp: Function) {
        return this.obdOffLineLog.Destroy(funcionResp);
    }

    public DestruirBDOff(funcionResp: Function) {
        return this.oServiceOffLine.Destroy(funcionResp);
    }

    public SumarCtivo(idm3: string) {
        // var sPart1;
        // var sPart2;

        // sPart1 = idm3.substring(0, 8);
        // sPart2 = idm3.substring(8, idm3.length);
        // sPart2 = +sPart2 + 1;
        // idm3 = sPart1 + sPart2;
        // return idm3;
        var sPart1;
        var sPart2;
        sPart1 = idm3.substring(0, 9);
        sPart2 = idm3.substring(9);
        sPart2 = +sPart2 + 1;
        idm3 = sPart1 + "" + sPart2;
        return idm3;
    }

    /**
     * Actualizar el M3 Procesos, teniendo el Id del documento guardado en la BD NoSQL
     * @param id Id del documento Bd NoSQL
     * @param olM3Procesos M3 Procesos a almacenar / Actualizar
     * @param ResponseOKLoadM3Procesos Respuesta de OK.
     */
    public updProceso(id, olM3Procesos, ResponseOKLoadM3Procesos: Function, intento = 0) {

        this.oServiceOffLine.AddDocument(id.toString(), olM3Procesos).then(x => {
            //ResponseOKLoadM3Procesos(id);
            this.AddLogOffline(olM3Procesos, ResponseOKLoadM3Procesos);
        }, error => {
            var sFechaNow: string = moment(new Date()).format('YYYYMMDDTHHmmss')
            localStorage.setItem("errorLog" + sFechaNow, JSON.stringify({ "error": error, "olM3Procesos": olM3Procesos, "Intento": intento, "function": "updProceso" }));
            if (intento == 0) {
                this.obdOffLineLog.InstanceAgain();
                this.updProceso(id, olM3Procesos, ResponseOKLoadM3Procesos, 1);
            } else {
                ResponseOKLoadM3Procesos({ "Error": "Error en guardar en base de datos pcpal." })
            }
        });
    }


    /**
     * Actualizar el M3 Procesos, teniendo el Id del documento guardado en la BD NoSQL
     * @param id Id del documento Bd NoSQL
     * @param olM3Procesos M3 Procesos a almacenar / Actualizar
     */
    public async updProcesoAsync(id, olM3Procesos) {
        await this.oServiceOffLine.AddDocument(id.toString(), olM3Procesos);
        this.AddLogOffline(olM3Procesos, null);
    }

    public GetAllDocsOffLineSinDocs() {
        return this.oServiceOffLine.GetAllDocsOffLineSinDocs();
    }

    procesarTicketOffline(idkatios, proceso, oDataUser: any, funcionResp: Function) {
        var lM3Procesos = new Array<M3Procesos>();
        var oM3RegService = new M3RegService(null, null, idkatios);

        if (this.ValidarTicketCerrado(proceso)) {
            lM3Procesos.push(proceso);

            oM3RegService.RegistroEventoM3OffLine(idkatios, this.oPostServiceM3, lM3Procesos, oDataUser).then(x => {
                if (x) {
                    funcionResp(true, "OK");
                } else {
                    funcionResp(false, "OK");
                }
            }).catch(function (err) {
                funcionResp(false, err);
            });
        }
    }


    /**
     * Valida procesos que se procesaron mientras se estaba fuera de linea
     */
    public ValidarProcesosAgregadosOffLine(idkatios, oDataUser: any, funcionResp: Function) {
        //console.log("Entro ValidarProcesosAgregadosOffLine")
        var lM3Procesos = new Array<M3Procesos>();
        var oM3RegService = new M3RegService(null, null, idkatios);
        this.oServiceOffLine.GetAllDocs().then(result => {
            // handle result
            for (var i = 0; i < result.rows.length; i++) {
                if (!result.rows[i].id.startsWith("CTIVOS")) {
                    var m3Proceso: M3Procesos = result.rows[i].doc;
                    if (this.ValidarTicketCerrado(m3Proceso)) {
                        lM3Procesos.push(result.rows[i].doc);
                    }
                }
            }
            //console.log("Antes RegistroEventoM3OffLine")
            oM3RegService.RegistroEventoM3OffLine(idkatios, this.oPostServiceM3, lM3Procesos, oDataUser).then(x => {
                // console.log("Dio Respuesta RegistroEventoM3OffLine")
                // console.log(x)
                if (x) {
                    //console.log("if 1")
                    this.oServiceOffLine.DeleteAllDocs();
                    funcionResp(true, "OK");
                } else {
                    //console.log("if 2")
                    //Respuesta con errores
                    //this.oServiceOffLine.DeleteAllDocs();
                    funcionResp(false, "OK");
                }
            }).catch(function (err) {
                funcionResp(false, err);
            });
        }).catch(function (err) {
            console.log(err);
            funcionResp(false, err);
        });
    }

    /**
     * Validacion de que el ticket esta cerrado.
     * @param m3Proceso 
     */
    public ValidarTicketCerrado(m3Proceso: M3Procesos) {
        var bCerrado: boolean = true;
        if (m3Proceso && m3Proceso.SubEstadoAnt != "Declinado" && m3Proceso.M3ENC.length > 0 && m3Proceso.lM3PEncFP.length == 0 &&
            this.getCantidadTotalByM3Proceso(m3Proceso) > 0) {
            bCerrado = false;
        }
        return bCerrado;
    }


    public getCantidadTotalByM3Proceso(oM3Procesos: M3Procesos) {
        if (oM3Procesos && oM3Procesos.M3ENC) {
            var dCantidad = oM3Procesos.M3ENC.filter(enc => (+enc.M3DET.find(det => det.NombreConcepto == "CANTIDAD").Valor) > 0).
                reduce((acc, cur) => (acc) + (+cur.M3DET.find(det => det.NombreConcepto == "CANTIDAD").Valor), 0);
            if (dCantidad == 0) {
                return 0;
            } else {
                return dCantidad;
            }
        } else {
            return 0;
        }
    }



    /**
     * Obtener todos los documentos Off line que se han guardado como offline.
     */
    public async GetAllDocsOffline() {
        try {
            var lM3Procesos = new Array<M3Procesos>();
            var result = await this.oServiceOffLine.GetAllDocs();
            for (var i = 0; i < result.rows.length; i++) {
                if (result.rows[i].id != "CTIVOS") {
                    lM3Procesos.push(result.rows[i].doc);
                }
            }
            return lM3Procesos;
        } catch {
            return null;
        }
    }


    /**
     * Obtener todos los documentos Off line que se han guardado como offline.
     */
    public GetAllDocsOfflineDeleted() {
        return this.oServiceOffLine.GetAllDocsDeleted();
    }

    public deleteCtivos(ubicacion: string, hub: string) {
        var data = this.oServiceOffLine.Delete(this.GetKey(ubicacion, hub))
        return data;
    }

    public getAllCtivos(ubicacion: string, hub: string) {
        return this.oServiceOffLine.get(this.GetKey(ubicacion, hub))
    }


    /**
     * Valida los consecutivos que estan localmente vs los que estan en el servidor.
     */
    public ValidacionCtivosVSServer(ikatios: string, ubicacion: string, idHub: string, funcionResp: Function) {
        this.getAllCtivos(ubicacion, idHub).then(x => {
            if (x) {
                var oServiceM3Maestro = new ServiceM3Maestro();
                oServiceM3Maestro.ValidarCtivosVSLocal(this.oPostServiceM3, ikatios, JSON.stringify(x), ubicacion, idHub, funcionResp);
            }
        })
    }

    /**
     * Obtener el consecutivo en el que va, el proceso offline que recibe como parametro
     * @param ubicacion 
     * @param hub 
     * @param sIdProceso 
     */
    public async GetCtivoOffLine(ubicacion: string, hub: string, sIdProceso: string) {
        var ctivo: string = "0";
        try {
            var oData = await this.oServiceOffLine.get(this.GetKey(ubicacion, hub));
            if (oData) {
                var oDataFinded: any = oData.Ctivos.find(x => x.IdProceso == sIdProceso);
                if (oDataFinded.Ctivo) {
                    ctivo = oDataFinded.Ctivo.substring(9);
                }
            }
        } catch { }
        return ctivo;
    }

    /**
     * Guardar id m3 
     * @param sIdM3 
     * @param sIdProceso 
     */
    public SaveIdM3(sIdM3: string, sIdProceso: string, ubicacion: string, hub: string) {
        this.oServiceOffLine.get(this.GetKey(ubicacion, hub)).then(data => {
            var oData: Array<any> = data.Ctivos;
            var oDataFinded: any = oData.find(x => x.IdProceso == sIdProceso);
            if (oDataFinded) {
                var ctivoAnt = +oDataFinded.Ctivo.substring(9);
                var ctivoAct = +sIdM3.substring(9);
                if (ctivoAct > ctivoAnt) {
                    oDataFinded.Ctivo = sIdM3;
                }
            } else {
                oData.push({ "IdProceso": sIdProceso, "Ctivo": sIdM3 })
            }
            this.SaveCtivos(oData, ubicacion, hub);
            if (sIdProceso.toUpperCase() == "TICKETVENTA") {
                localStorage.setItem("CtivoTicketVenta", sIdM3);
            }
        }, error => {
            var oData = new Array<any>();
            oData.push({ "IdProceso": sIdProceso, "Ctivo": sIdM3 })
            this.SaveCtivos(oData, ubicacion, hub);
            if (sIdProceso.toUpperCase() == "TICKETVENTA") {
                localStorage.setItem("CtivoTicketVenta", sIdM3);
            }
        });
    }

    /**
     * Guardar ctivos, Idm3.
     * @param oData 
     */
    private SaveCtivos(oData: Array<any>, ubicacion: string, hub: string, intento = 0) {
        var oDataSend = { "Ctivos": oData }
        this.oServiceOffLine.AddDocument(this.GetKey(ubicacion, hub), oDataSend).then(x => {
            console.log("OK");
        }, error => {
            var sFechaNow: string = moment(new Date()).format('YYYYMMDDTHHmmss')
            localStorage.setItem("errorLogCtivos" + sFechaNow, JSON.stringify({ "error": error, "Ctivos": oDataSend, "function": "SaveCtivos" }));
            console.log(error);
            if (intento == 0) {
                this.SaveCtivos(oData, ubicacion, hub, 1)
            }
        });
    }

    public DeleteOldDocs(maxDias: number) {
        this.obdOffLineLog.DeleteOldDocs(maxDias)
    }


    /**
     * Obtener informacion de Id m3, cuando esta fuera de linea
     */
    private async GetIdM3Offline(idkatios: string, idproceso: string, ubicacion: string, hub: string) {
        var oDataIdM3;
        var idM3;
        try {
            oDataIdM3 = await this.oServiceOffLine.get(this.GetKey(ubicacion, hub));
            var oDataFinded: any = oDataIdM3.Ctivos.find(x => x.IdProceso == idproceso);
            if (oDataFinded) {
                idM3 = oDataFinded.Ctivo;
                idM3 = this.SumarCtivo(idM3);
                idM3 = this.validarAumentoCtivo(idM3, idproceso);
            } else {
                // var date = new Date();
                // idM3 = date.getFullYear() + "" + date.getMonth() + "" + date.getDay() + "" + date.getHours() + "" + date.getMinutes() + "" + date.getSeconds() + "" + date.getMilliseconds();

                idM3 = this.GetCtivo(idkatios, idproceso, ubicacion, hub);
            }
        } catch {
            // var date = new Date();
            // idM3 = date.getFullYear() + "" + date.getMonth() + "" + date.getDay() + "" + date.getHours() + "" + date.getMinutes() + "" + date.getSeconds() + "" + date.getMilliseconds();
            idM3 = this.GetCtivo(idkatios, idproceso, ubicacion, hub);
        }
        return idM3;
    }


    validarAumentoCtivo(idM3, idproceso) {
        if (idproceso.toUpperCase() == "TICKETVENTA") {
            let ultimoIdM3 = localStorage.getItem("CtivoTicketVenta");
            if (ultimoIdM3 == idM3) {
                var sFechaNow: string = moment(new Date()).format('YYYYMMDDTHHmmss')
                idM3 = this.SumarCtivo(idM3);
                localStorage.setItem("errorLogCtivos" + sFechaNow, JSON.stringify({ "idM3": idM3, "function": "validarAumentoCtivo" }));
            }
        }
        return idM3;
    }

    private async GetCtivo(idkatios: string, idproceso: string, ubicacion: string, hub: string) {
        var oServiceM3Maestro = new ServiceM3Maestro();
        var sCtivo;
        sCtivo = await oServiceM3Maestro.GetCtivoBYProceso(this.oPostServiceM3, idkatios, idproceso, ubicacion, hub);
        return sCtivo;
    }


    /**
     * Obtener llave de pouchDB
     * @param ubic 
     * @param hub 
     */
    public GetKey(ubic, hub) {
        return "CTIVOS_" + ubic + hub;
    }

}